// Annual service period: inclusive end = the day before the anniversary
// (1 Nov 2027 → 31 Oct 2028); the next period starts the following day.
export const annualPeriodEndIso = (startIso) => {
    const s = String(startIso || "").slice(0, 10);
    if (!s) return "";
    const d = new Date(`${s}T00:00:00Z`);
    if (Number.isNaN(d.getTime())) return "";
    const end = new Date(Date.UTC(d.getUTCFullYear() + 1, d.getUTCMonth(), d.getUTCDate()));
    end.setUTCDate(end.getUTCDate() - 1);
    return end.toISOString().slice(0, 10);
};
